import type { ColoredMaterialSpecification } from "@color-finder/color-finder-api/models";
import { NoData } from "components/dataDisplay/NoData";
import type { FunctionComponent, ReactNode } from "react";
import { formatGloss } from "service/measurement-condition";

export interface ColorMeasurementParametersProps {
  gloss: ColoredMaterialSpecification["gloss"];
  measurementMode: ColoredMaterialSpecification["measurementMode"];
}

export const MeasurementCondition: FunctionComponent<
  ColorMeasurementParametersProps
> = ({ gloss, measurementMode }) => {
  const parts = [measurementMode, formatGloss(gloss)]
    .filter((it) => !!it)
    .map<ReactNode>((it, idx) => <span key={idx}>{it}</span>);
  if (parts.length === 0) {
    return <NoData />;
  }
  return <>{parts.reduce((prev, curr) => [prev, ", ", curr])}</>;
};
